import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import { TextField } from '@material-ui/core'
// Constant
import Colors from '../../constants/Colors'

const useStyles = makeStyles(theme => ({
  textFieldLabel: {
    color: Colors.SECONDARY_FONT_COLOR,
    fontSize: 13,
    fontWeight: 'normal',
    marginTop: 0,
    transform: 'none',
  },
  textFieldInput: {
    border: `solid 1px ${Colors.DISABLED_COLOR}`,
    color: Colors.PRIMARY_FONT_COLOR,
    fontSize: 15,
    padding: '14px 10px',
    '&::placeholder': {
      color: Colors.SECONDARY_FONT_COLOR,
      opacity: 1,
    },
    '&:-ms-input-placeholder': {
      color: Colors.SECONDARY_FONT_COLOR,
    },
    '&::-ms-input-placeholder': {
      color: Colors.SECONDARY_FONT_COLOR,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  inputWithLabel: {
    marginTop: 6,
  },
  textAreaRoot: {
    padding: 0,
    '& > div': {
      display: 'inline-flex',
    },
  },
}))

const CustomTextField = ({ maxLength, ...textFieldProps }) => {
  const classes = useStyles()

  return (
    <TextField
      {...textFieldProps}
      margin='none'
      InputLabelProps={{
        disableAnimation: true,
        focused: false,
        shrink: true,
        classes: {
          root: classes.textFieldLabel,
        },
      }}
      InputProps={{
        disableUnderline: true,
        classes: {
          input: classNames(
            classes.textFieldInput,
            textFieldProps.label && classes.inputWithLabel,
          ),
          multiline: classes.textAreaRoot,
        },
        inputProps: {
          maxLength: maxLength,
        },
      }}
    />
  )
}

CustomTextField.propTypes = {
  maxLength: PropTypes.number,
}

export default CustomTextField
